export default "__VITE_ASSET__B4je4qT3__"